import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bill",
  "use": "icon-bill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bill\"><defs><style type=\"text/css\"></style></defs><path d=\"M930.496 96.64v832h-832v-832h832z m-89.6 90.304h-652.8V838.4h652.8V186.88z m-403.84 107.2l75.776 136.128L588.8 294.144h102.848L615.68 430.272l70.592 0.064v90.304H557.376v38.72h128.896v90.24H557.376v78.208h-89.6v-78.144h-128V559.36h128v-38.72h-128V430.4l70.272-0.128-75.712-136.128h102.656z\" p-id=\"3258\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol